//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import ServiceObjectMaintenanceNoteOperation from './ServiceObjectMaintenanceNoteOperation.vue'

export default {
  components: {
    ServiceObjectMaintenanceNoteOperation
  },
  props: {
    action: {
      type: Object,
      default: null
    },
    notes: {
      type: Array,
      default: () => []
    },
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      loading: false,
      canSkipMaintenanceNote: false
    }
  },
  computed: {
    disableSave: function () {
      return this.notes.some(note => !note.selectedFastFixMode)
    },
    displayBtnSkip: function () {
      return this.canSkipMaintenanceNote
    }
  },
  created: function () {
    this.updateCanSkipMaintenanceNote()
  },
  methods: {
    clear: function () {
      this.notes.forEach(note => {
        note.selectedFastFixMode = null
        note.validate = null
      })
    },
    onClose: function () {
      this.clear()
      this.$emit('cancel')
    },
    onSave: async function (skip = false) {
      let notes = []
      let promises = []
      if (this.$refs.serviceObjectMaintenanceNoteOperation) {
        notes = Array.isArray(this.$refs.serviceObjectMaintenanceNoteOperation)
          ? this.$refs.serviceObjectMaintenanceNoteOperation
          : [this.$refs.serviceObjectMaintenanceNoteOperation]

        let valid = true
        for (const note of notes) {
          valid = skip || note.onValidate() && valid
        }

        if (valid) {
          promises = notes.map(note => note.onSave(skip))

          try {
            await Promise.all(promises)
            this.clear()

            // Завершаем работы в отчете после всех успешных запросов
            this.$emit('done')
          } catch (error) {
            console.error('Ошибка при изменении замечания к объекту обслуживания:', error)
          }
        }
      }
    },
    updateCanSkipMaintenanceNote: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/user/current',
        onSuccess: (response) => {
          const user = response.data
          this.canSkipMaintenanceNote = user.employee && user.employee.canSkipMaintenanceNote
        },
        onFailure: 'Ошибка получения информации о текущем пользователе'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

